import { HowOftenReachOutOptionsType } from './types';

export const HOW_OFTEN_REACH_OUT_OPTIONS: HowOftenReachOutOptionsType = [
  { id: 'constant', title: 'Constant — he texts all day', icon: '💬' },
  { id: 'once_twice', title: 'Once or twice a day, with love', icon: '💌' },
  { id: 'when_matters', title: 'Just when it matters most', icon: '💎' },
  { id: 'let_me_first', title: 'Let me message first', icon: '🖐️' },
];
